var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isRegular
      ? _c("span", [_vm._v("\n    Regular\n  ")])
      : _vm.isGroupMessage
      ? _c(
          "span",
          [
            _vm.isGroupMessage
              ? _c(
                  "el-tooltip",
                  {
                    attrs: {
                      effect: "light",
                      placement: "left",
                      content: "Group message",
                    },
                  },
                  [
                    _c("span", [
                      _c("i", { staticClass: "fas fa-users mr-1" }),
                      _vm._v(" Group\n      "),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }